import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"width":"80px"} }

import SogPage from "@/shared/ui/SogPage.vue";
import {onBeforeRouteUpdate, RouteLocationNormalizedLoaded, useRoute, useRouter} from "vue-router";
import {useAccountStore} from "@/stores/accountStore";
import {computed, onMounted, reactive, ref, watch} from "vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import {useNavigationStore} from "@/modules/Navigation/store";
import apiOrder from "@/modules/Order/api";
import apiFile from "@/shared/services/apiFile";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import OrderListComponent from "@/modules/Order/components/OrderListComponent.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import SogDropDownList from "@/shared/ui/SogDropDownList.vue";
import {useSpinner} from "@/shared/composables/SogSpinner";
import {addDays} from "@/shared/utils/DateUtils";
import {IdType} from "@/shared/model/idType";
import {useOrderStore} from "@/modules/Order/store";
import {storeToRefs} from "pinia";
import Person from "@/shared/model/person";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import ConfigItem from "@/shared/model/ConfigItem";
import delay from "@/shared/utils/delay";



export default /*@__PURE__*/_defineComponent({
  __name: 'OrderListPage',
  setup(__props) {

const _router = useRouter()
const _config = useAccountStore()
const _orderStore = useOrderStore();
const _spinner = useSpinner()
const _title = ref("");
const _navigationStore = useNavigationStore()
const _listComponent = ref<InstanceType<typeof OrderListComponent> | null>(null)

const _sector = ref("");
const _type = ref("");
const _filterType = ref("");
const _selectedOrderId = ref<string | undefined>(undefined);
const _selectedOrderNumber = ref<string | undefined>(undefined);
const _lstYes = reactive([{id: "yes", value: "Ja"}, {id: "all", value: "Alle"}]);
const _personAll = new Person();
const _lstPerson = ref<Person[]>([_personAll]);
const _fields = {text: 'value', value: 'id'}
const {listPage: _listPage} = storeToRefs(_orderStore)
const _overdue = ref(_listPage.value.overdue)
const _personId = ref(_listPage.value.personId)
const _fieldsPerson = {text: 'personName', value: 'id'}
const _auszieffernAm = ref<Date|undefined>();
const _auszieffernPerson = ref("")

_personAll.id = "all";
_personAll.personName = "Alle";

function p_setTitle() {
  _title.value = "";
  if (_sector.value === "purchase") {
    _title.value = "Eingangs"
  }
  if (_sector.value === "sale") {
    _title.value = "Ausgangs"
  }
  if (_type.value === "Order") {
    _title.value += "bestellungen"
  }
  if (_type.value === "Invoice") {
    _title.value += "rechnungen"
  }
  if (_filterType.value === "person" && _navigationStore.currentPersonId) {
    _title.value += " für " + _navigationStore.currentPersonName
  }
}


const _isAusziffernVisible = computed(()=>{
  return _config.isRoot && _sector.value==='sale'&& _type.value==='Invoice';
})


async function init(route: RouteLocationNormalizedLoaded) {
  await p_loadPersons();
  _sector.value = route.params.sector as string;

  if (!_config.hasAction(_sector.value)) {
    await _router.push("/")
    return
  }


  _type.value = route.params.type as string;
  _filterType.value = route.params.filtertype as string;
  _selectedOrderId.value = "";
  _overdue.value = _type.value==='Invoice'?_listPage.value.overdue:"all"
  _personId.value = _listPage.value.personId

  p_loadAusziffern();


  p_setTitle()
  onSearch()

}

onMounted(() => {
  const route = useRoute();
  init(route)
})

onBeforeRouteUpdate((to) => {
  init(to)
});




function onShowInsurance() {
  if (_selectedOrderId.value) {
    _navigationStore.showInsuranceList(IdType.Order, _selectedOrderId.value)
  }
}

async function onDetails() {
  if (_selectedOrderId.value) {
    await _navigationStore.showObject(IdType.Order, _selectedOrderId.value);
  }
}

async function onPrint() {
  if (_selectedOrderId.value) {
    try {
      _spinner.show();
      const id = await apiOrder.orderInitPdf(_selectedOrderId.value)
      if (id) {
        await apiFile.downloadFile(id, _selectedOrderNumber.value + ".pdf")
      }
    } finally {
      _spinner.hide();
    }
  }
}

function onSearch() {
  _listComponent.value?.adaptor.removePredicate("orderNumber");
  if (_listPage.value.number)
    _listComponent.value?.adaptor.addPredicate("orderNumber", "contains", _listPage.value.number.toUpperCase());

  _listComponent.value?.adaptor.removePredicate("paid");
  _listComponent.value?.adaptor.removePredicate("ordereddate");
  if (_overdue.value === "yes") {
    _listComponent.value?.adaptor.addPredicate("paid", "equal", "false");
    const t_date: Date = addDays(new Date(), -15)
    _listComponent.value?.adaptor.addPredicate("ordereddate", "lessthan", t_date);
  }

  if(_filterType.value !== "person") {
    _listComponent.value?.adaptor.removePredicate("personId");
    if (_personId.value !== "all") {
      _listComponent.value?.adaptor.addPredicate("personId", "equal", _personId.value);
    }
  }

  _listComponent.value?.refresh();
}


watch(_overdue, () => {
      _listPage.value.overdue = _overdue.value
      onSearch()
    }
)

watch(_personId, () => {
      _listPage.value.personId = _personId.value
      onSearch()
    }
)

function onExportExcel() {
  _listComponent.value?.excelExport()
}

function onSelected(data: any | undefined) {
  _selectedOrderId.value = data?.id;
  _selectedOrderNumber.value = data?.orderNumber
}

async function p_loadPersons() {
  const t_res = await apiOrder.personList()
  if(t_res)
    _lstPerson.value = [_personAll,...t_res];
}

async function onClickAusziffernNow() {

  const t_item = new ConfigItem();
  t_item.key = "AusziffernDatum";
  t_item.setAsDateTime(new Date());

  const t_updateDate = apiOrder.updateConfig(t_item);
  t_item.key = "AusziffernPerson";
  t_item.value = _config.actionPerson?.getFullPersonName();
  const t_updatePerson = apiOrder.updateConfig(t_item);

  await Promise.all([t_updateDate, t_updatePerson]);
  await p_loadAusziffern()
}

async function p_loadAusziffern() {
  if(!_isAusziffernVisible.value)
    return;

  const t_res = await apiOrder.loadConfig(["AusziffernDatum","AusziffernPerson"]);
  if (t_res) {
    _auszieffernAm.value = undefined;
    _auszieffernPerson.value = ""
    t_res.forEach(t=>{
      if(t.key === "AusziffernDatum"){
        _auszieffernAm.value = t.getAsDateTime()
      }
      else if(t.key === "AusziffernPerson"){
        _auszieffernPerson.value = t.value??""
      }
    })
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, { title: _title.value }, {
    default: _withCtx(() => [
      _createVNode(SogFlexRow, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(SogCard, null, {
            default: _withCtx(() => [
              _createVNode(SogCardTitle, null, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("Letzte Auszifferung", -1)
                ]))]),
                _: 1
              }),
              _createVNode(SogCardContent, null, {
                default: _withCtx(() => [
                  _cache[4] || (_cache[4] = _createTextVNode(" um ", -1)),
                  _createVNode(SogDataLabel, {
                    value: _auszieffernAm.value,
                    "value-type": _unref(SogDataLabelValueType).DateTime
                  }, null, 8, ["value", "value-type"]),
                  _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                  _createVNode(SogDataLabel, { value: _auszieffernPerson.value }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(SogCardActions, null, {
                default: _withCtx(() => [
                  _createVNode(SogCardActionButton, { onClick: onClickAusziffernNow }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode(" Jetzt ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512), [
            [_vShow, _isAusziffernVisible.value]
          ]),
          _createVNode(SogCard, null, {
            default: _withCtx(() => [
              _createVNode(SogCardActions, null, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(SogCardActionButton, {
                    "mdi-icon": "mdi-information",
                    onClick: onDetails
                  }, null, 512), [
                    [_vShow, _selectedOrderId.value]
                  ]),
                  _withDirectives(_createVNode(SogCardActionButton, {
                    "mdi-icon": "mdi-printer",
                    onClick: onPrint
                  }, null, 512), [
                    [_vShow, _selectedOrderId.value]
                  ]),
                  _withDirectives(_createVNode(SogCardActionButton, { onClick: onShowInsurance }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode(" Versicherungskarten ", -1)
                    ]))]),
                    _: 1
                  }, 512), [
                    [_vShow, _selectedOrderId.value]
                  ]),
                  _createVNode(SogTextBox, {
                    modelValue: _unref(_listPage).number,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(_listPage).number) = $event)),
                    placeholder: "Nummer",
                    "interval-modified": onSearch
                  }, null, 8, ["modelValue"]),
                  _withDirectives(_createVNode(SogDropDownList, {
                    modelValue: _personId.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_personId).value = $event)),
                    placeholder: "Name",
                    "data-source": _lstPerson.value,
                    fields: _fieldsPerson
                  }, null, 8, ["modelValue", "data-source"]), [
                    [_vShow, _filterType.value !== 'person']
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_1, [
                    _createVNode(SogDropDownList, {
                      modelValue: _overdue.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_overdue).value = $event)),
                      placeholder: "überfällig",
                      "data-source": _lstYes,
                      fields: _fields,
                      "popup-width": "80px"
                    }, null, 8, ["modelValue", "data-source"])
                  ], 512), [
                    [_vShow, _type.value==='Invoice']
                  ]),
                  _createVNode(SogCardActionButton, {
                    kind: _unref(SogButtonKind).Search,
                    style: {"align-self":"flex-end"},
                    onClick: onSearch
                  }, null, 8, ["kind"]),
                  _createVNode(SogCardActionButton, {
                    "mdi-icon": "mdi-file-excel",
                    onClick: onExportExcel
                  }),
                  _createVNode(SogCardActionButton, {
                    kind: _unref(SogButtonKind).Back,
                    style: {"align-self":"flex-end"}
                  }, null, 8, ["kind"])
                ]),
                _: 1
              }),
              _createVNode(SogCardContent, null, {
                default: _withCtx(() => [
                  _createVNode(OrderListComponent, {
                    ref_key: "_listComponent",
                    ref: _listComponent,
                    onSelected: onSelected
                  }, null, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})